import { render, staticRenderFns } from "./DataSheet.vue?vue&type=template&id=67e4744d&"
import script from "./DataSheet.vue?vue&type=script&lang=ts&"
export * from "./DataSheet.vue?vue&type=script&lang=ts&"
import style0 from "./DataSheet.vue?vue&type=style&index=0&id=67e4744d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports